module.exports = __webpack_public_path__ + "static/media/Eddie Kassaei.2969950b.png";